export const CHECKLISTS = [
  {
    id: "generador",
    icon: "Zap",
    title: { es: "Seguridad y Mantenimiento de la Planta Eléctrica", en: "Generator Safety & Maintenance" },
    items: [
      { es: "Instalar detectores de monóxido de carbono con baterías nuevas", en: "Install carbon monoxide detectors with fresh batteries" },
      { es: "Operar la planta al aire libre, a 20+ pies de puertas y ventanas", en: "Run the generator outdoors, 20+ feet from doors and windows" },
      { es: "Verificar nivel de aceite antes de cada uso prolongado", en: "Check oil level before every extended use" },
      { es: "Almacenar gasolina en envases aprobados, lejos del calor", en: "Store fuel in approved containers, away from heat" },
      { es: "Apagar y enfriar la planta antes de rellenar combustible", en: "Turn off and cool the generator before refueling" },
      { es: "Instalar interruptor de transferencia con electricista certificado", en: "Install a transfer switch with a certified electrician" },
      { es: "Probar la planta mensualmente por 15-20 minutos", en: "Test-run the generator monthly for 15-20 minutes" },
      { es: "Tener extensiones de calibre grueso aprobadas para exteriores", en: "Keep heavy-gauge outdoor-rated extension cords" },
      { es: "Guardar repuestos: bujías, filtros de aire y aceite", en: "Stock spares: spark plugs, air filters and oil" },
      { es: "Registrar fechas de mantenimiento en una libreta", en: "Log maintenance dates in a notebook" },
    ],
  },
  {
    id: "evacuacion",
    icon: "Route",
    title: { es: "Plan de Evacuación Familiar", en: "Family Evacuation Plan" },
    items: [
      { es: "Trazar dos rutas de salida desde su hogar", en: "Map two exit routes from your home" },
      { es: "Identificar el refugio municipal más cercano", en: "Identify the nearest municipal shelter" },
      { es: "Designar un punto de encuentro fuera del vecindario", en: "Designate a meet-up point outside the neighborhood" },
      { es: "Elegir un contacto fuera de PR para coordinar a la familia", en: "Choose an out-of-island contact to coordinate family" },
      { es: "Aprender a cerrar agua, gas y electricidad", en: "Learn how to shut off water, gas and electricity" },
      { es: "Mochila de emergencia lista junto a la puerta principal", en: "Go-bag ready by the main door" },
      { es: "Plan para mascotas con transportín y alimento", en: "Pet plan with carrier and food" },
      { es: "Practicar el plan dos veces al año con todos en casa", en: "Drill the plan twice a year with everyone at home" },
      { es: "Documentos importantes en bolsa impermeable", en: "Important documents in a waterproof bag" },
      { es: "Mantener el tanque del vehículo sobre la mitad", en: "Keep the vehicle tank above half" },
    ],
  },
  {
    id: "kits",
    icon: "Backpack",
    title: { es: "Kits de Emergencia — Hogar y Vehículo", en: "Emergency Kits — Home & Vehicle" },
    items: [
      { es: "Agua: 1 galón por persona por día, mínimo 10 días", en: "Water: 1 gallon per person per day, 10 days minimum" },
      { es: "Alimentos no perecederos y MREs para 10 días", en: "Non-perishable food and MREs for 10 days" },
      { es: "Botiquín de primeros auxilios completo", en: "Complete first-aid kit" },
      { es: "Medicamentos recetados para 30 días", en: "30-day supply of prescription medications" },
      { es: "Power banks cargados y radio de manivela o baterías", en: "Charged power banks and crank or battery radio" },
      { es: "Efectivo en denominaciones pequeñas", en: "Cash in small denominations" },
      { es: "Linternas y baterías de repuesto", en: "Flashlights and spare batteries" },
      { es: "Silbato, mascarillas y toallitas húmedas", en: "Whistle, face masks and wet wipes" },
      { es: "En el vehículo: cables de arranque, gato y herramientas", en: "In the vehicle: jumper cables, jack and basic tools" },
      { es: "Copias de documentos en USB y en la nube", en: "Document copies on USB and in the cloud" },
    ],
  },
  {
    id: "cisterna",
    icon: "Droplets",
    title: { es: "Mantenimiento de Cisterna y Agua de Lluvia", en: "Cistern & Rainwater System Maintenance" },
    items: [
      { es: "Limpiar y desinfectar la cisterna cada 6 meses", en: "Clean and disinfect the cistern every 6 months" },
      { es: "Probar la bomba de agua mensualmente", en: "Test the water pump monthly" },
      { es: "Tratar el agua almacenada con cloro según dosis oficial", en: "Treat stored water with chlorine per official dosing" },
      { es: "Revisar tapas y sellos contra mosquitos", en: "Check lids and seals against mosquitoes" },
      { es: "Instalar filtro de sedimentos en la entrada", en: "Install a sediment filter at the inlet" },
      { es: "Medir el nivel de agua semanalmente", en: "Measure water level weekly" },
      { es: "Tener pastillas purificadoras de respaldo", en: "Keep backup purification tablets" },
      { es: "Separar agua potable del agua de uso general", en: "Separate drinking water from utility water" },
      { es: "Revisar tuberías por fugas", en: "Inspect plumbing for leaks" },
      { es: "Localizar el oasis o punto de distribución de AAA cercano", en: "Locate the nearest AAA water distribution point" },
    ],
  },
  {
    id: "cuidados",
    icon: "HeartPulse",
    title: { es: "Cuidados Especiales — Mayores y Niños", en: "Special Care — Seniors & Children" },
    items: [
      { es: "Reserva de energía dedicada para CPAP y oxígeno", en: "Dedicated backup power for CPAP and oxygen" },
      { es: "Lista de medicamentos y dosis de cada familiar", en: "Medication and dosage list for each family member" },
      { es: "Plan para insulina: neverita con packs de hielo", en: "Insulin plan: cooler with ice packs" },
      { es: "Inscribir a personas de necesidades especiales en el registro municipal", en: "Register special-needs persons in the municipal registry" },
      { es: "Equipo de movilidad extra: bastón, andador, silla de ruedas", en: "Spare mobility equipment: cane, walker, wheelchair" },
      { es: "Pañales, fórmula y artículos de confort para bebés", en: "Diapers, formula and comfort items for toddlers" },
      { es: "Juguetes y actividades para reducir la ansiedad infantil", en: "Toys and activities to ease child anxiety" },
      { es: "Contactos de médicos y farmacias impresos en papel", en: "Printed doctor and pharmacy contacts" },
      { es: "Plan de transporte para familiares sin vehículo", en: "Transportation plan for family members without a car" },
      { es: "Guardar la Línea PAS 1-800-981-0023 para apoyo emocional", en: "Save the PAS Line 1-800-981-0023 for emotional support" },
    ],
  },
];
